class ProductMediaExtraDesktop {
  constructor(root) {
    if (window.innerWidth < 750) return;

    this.root = root;
    this.track = root.querySelector('[data-extra-carousel-track]');
    this.slides = Array.from(root.querySelectorAll('[data-extra-carousel-slide]'));
    this.prevButton = root.querySelector('[data-extra-carousel-prev]');
    this.nextButton = root.querySelector('[data-extra-carousel-next]');
    this.viewport = root.querySelector('.product-media-extra-desktop__viewport');
    this.index = 0;

    if (!this.root || !this.track || !this.viewport || !this.slides.length) return;

    this.handlePrevClick = this.handlePrevClick.bind(this);
    this.handleNextClick = this.handleNextClick.bind(this);

    this.bindEvents();
    this.update(false);
    this.root.classList.add('is-ready');

    this.reinitMagnifier();
  }

  bindEvents() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', this.handlePrevClick);
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', this.handleNextClick);
    }
  }

  handlePrevClick() {
    if (this.index <= 0) return;
    this.index -= 1;
    this.update(true);
  }

  handleNextClick() {
    if (this.index >= this.slides.length - 1) return;
    this.index += 1;
    this.update(true);
  }

  update(animate = true) {
    if (!this.track || !this.slides.length) return;

    const activeSlide = this.slides[this.index];
    if (!activeSlide) return;

    if (this.slides.length <= 1) {
      this.root.classList.add('is-single-slide');
    } else {
      this.root.classList.remove('is-single-slide');
    }

    this.track.style.transition = animate ? 'transform 0.3s ease' : 'none';

    const translateY = activeSlide.offsetTop;
    this.track.style.transform = `translateY(-${translateY}px)`;

    this.viewport.style.height = `${activeSlide.offsetHeight}px`;

    if (this.prevButton) {
      this.prevButton.disabled = this.index === 0 || this.slides.length <= 1;
    }

    if (this.nextButton) {
      this.nextButton.disabled = this.index >= this.slides.length - 1 || this.slides.length <= 1;
    }

    this.reinitMagnifier();
  }

  reinitMagnifier() {
    const magnifierItems = this.root.querySelectorAll('[data-magnifier="true"]');

    if (!magnifierItems.length) return;

    requestAnimationFrame(() => {
      magnifierItems.forEach((item) => {
        item.classList.remove('is-magnifying', 'is-magnifier-active');
      });

      if (typeof window.ProductMediaMagnifier?.init === 'function') {
        window.ProductMediaMagnifier.init();
      } else {
        document.dispatchEvent(new CustomEvent('product:magnifier:refresh'));
      }
    });
  }

  destroy() {
    if (this.prevButton) {
      this.prevButton.removeEventListener('click', this.handlePrevClick);
    }

    if (this.nextButton) {
      this.nextButton.removeEventListener('click', this.handleNextClick);
    }

    this.track.style.transition = '';
    this.track.style.transform = '';
    this.viewport.style.height = '';
    this.root.classList.remove('is-ready', 'is-single-slide');
  }
}

const extraDesktopInstances = new WeakMap();

function initExtraDesktopGalleries(scope = document) {
  if (window.innerWidth < 750) return;

  const galleries = scope.querySelectorAll('[data-extra-desktop-gallery]');

  galleries.forEach((gallery) => {
    if (extraDesktopInstances.has(gallery)) return;

    const instance = new ProductMediaExtraDesktop(gallery);
    extraDesktopInstances.set(gallery, instance);
  });
}

function destroyExtraDesktopGalleries() {
  document.querySelectorAll('[data-extra-desktop-gallery]').forEach((gallery) => {
    const instance = extraDesktopInstances.get(gallery);

    if (instance) {
      instance.destroy();
      extraDesktopInstances.delete(gallery);
    }
  });
}

function refreshExtraDesktopGalleries() {
  destroyExtraDesktopGalleries();

  if (window.innerWidth < 750) return;

  initExtraDesktopGalleries();
}

document.addEventListener('DOMContentLoaded', () => {
  initExtraDesktopGalleries();

  const observer = new MutationObserver(() => {
    refreshExtraDesktopGalleries();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  let resizeTimer;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {
      refreshExtraDesktopGalleries();
    }, 150);
  });

  document.addEventListener('variant:change', () => {
    refreshExtraDesktopGalleries();
  });
});